import { Observable } from 'rxjs/Observable';
import { removeFavorite } from '../utils/api';
import { FavoriteApi } from '../parsers';
import {
  REMOVE_FAVORITE_REQUEST,
  removeFavoriteSucceeded,
  removeFavoriteFailed,
} from '../redux/favorites';
import type { ActionObs, Store, Obs } from '../types';

export default function removeFavoriteEpic(
  action$: ActionObs,
  store: Store,
): Obs {
  return action$
    .ofType(REMOVE_FAVORITE_REQUEST)
    .switchMap(({ payload: { packageId } }) => {
      return removeFavorite({ packageId })
        .map(resp => FavoriteApi.parse(resp))
        .map(({ favorite }) => removeFavoriteSucceeded(favorite))
        .catch(err =>
          Observable.of(removeFavoriteFailed(`${packageId} ${err.message}`)),
        );
    });
}
